/**
 * ## State change engine
 *
 * Receives data from socket or REST route, validates against the domain
 * model, and integrates data into the local data store
 *
 * @module client/state
 */

"use strict";

const Promise = require("bluebird");
const uuid = require("node-uuid");
const error = require("../../common").error;
const validate = require("../../common").validate;

/**
 * State object create event handler
 *
 * @param {Object} proposed - unvalidated, no metadata json proposed object
 * @param {Object} db - current client db
 * @returns {Promise} - Resolving to validated, metadata, merged with proposed store
 * object
 */

const update = (proposed, db) => {
  if (proposed.domain == "location" && proposed._kd.site_id == "embed") {
    proposed._id = "embed";
  }
  if (!proposed.hasOwnProperty("_id")) {
    proposed._id = uuid.v4();
  }
  const valresult = validate.proposed(proposed);
  if (!valresult.valid) {
    return Promise.reject(
      new error.ValidationError(
        "Proposed data did not validate",
        proposed,
        valresult
      )
    );
  }
  return db.upsert(proposed.domain, proposed);
};

const initialize = (proposed, _socket) => {
  if (
    proposed.hasOwnProperty("domain") &&
    proposed.hasOwnProperty("lastsync") &&
    proposed.lastsync > -1
  ) {
    _socket.emit(`${proposed.domain}.initialize`, proposed);
    return true;
  }
  if (proposed.hasOwnProperty("domain")) {
    _socket.emit(`${proposed.domain}.error`, proposed);
  }
  return false;
};

module.exports = {
  update,
  initialize,
};



/** WEBPACK FOOTER **
 ** ./src/client/state/index.js
 **/